import { LaunchCard, LaunchCardSkeleton } from "@/components/LaunchCard";

export const NextLaunchSection = ({ loading, launch }) => (
  <section>
    <h2 className="section-title mb-4 flex items-center gap-2">
      <span className="w-2 h-2 rounded-full bg-ignition-red animate-pulse" />
      Next Launch
    </h2>
    {loading ? (
      <LaunchCardSkeleton featured />
    ) : launch ? (
      <LaunchCard launch={launch} featured />
    ) : (
      <div className="glass-card p-8 text-center">
        <p className="text-slate-400">No upcoming launches scheduled</p>
      </div>
    )}
  </section>
);
